module.exports = __webpack_public_path__ + "static/media/ochaco-uraraka-win.f6867745.png";